import {isNullOrUndefined} from "../../../../services/Validator";
import {
    renderScoreEmoji
} from "../../../../controllers/flashScreens/resultsStepScreen/ResultsScoreEmojiImageController";

function ResultsScoreEmojiImage({successRatio, openAppreciation}) {
    // Used in FlashResultsScore to show bear emoji related
    // to total score

    // BUILD
    if (isNullOrUndefined(successRatio))
        return null;
    return (
        <div className={"cursor-pointer h-[100px] min-h-[100px]"}
             onClick={() => openAppreciation()}>
            <img className={"h-[80px]"}
                 src={renderScoreEmoji(successRatio)}
                 alt={"Emotion"} />
        </div>
    );
}

// EXPORT
export default ResultsScoreEmojiImage